import { JobApproved } from "../components/Approved/JobApproved";
import { JobCompleted } from "../components/Completed/JobCompleted";
import { JobInProgress } from "../components/InProgress/JobInProgress";
import { JobScheduled } from "../components/Scheduled/JobScheduled";
import JobSummary from "../components/Summary/JobSummary";

export const componentMap = {
  forRevision: JobSummary,
  approved: JobApproved,
  scheduled: JobScheduled,
  inProgress: JobInProgress,
  completed: JobCompleted,
};
